exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.field-tip[data-v-00746964] {\n  color: #999;\n  font-size: 12px;\n  margin-left: 10px;\n}\n.media-preview[data-v-00746964] {\n  margin-top: 8px;\n}\n.media-preview img[data-v-00746964] {\n  max-width: 320px;\n  max-height: 180px;\n  border: 1px solid #eee;\n  border-radius: 4px;\n}\n.media-preview video[data-v-00746964] {\n  max-width: 320px;\n  max-height: 180px;\n  border: 1px solid #eee;\n  border-radius: 4px;\n  display: block;\n}\n", ""]);

// exports
